/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import defaultsDeep from 'lodash/defaultsDeep';
import {
  backLink,
  backLinkShowed,
  container,
  containerMoved,
  containerMovedOver, fadedBottom, fadedTop,
  fixedBack,
  fixedBackShowed,
  fixedContainer,
  flexed,
  itemContent,
  itemContentShowed,
  itemContentShowedFully,
  itemsContainer,
  subTitle,
  title,
  titleContainer,
  width100,
  wrapper,
} from './index.styles';
import { Icon } from '../../ui/Icon';
import { isMobileOnly, isTablet } from 'react-device-detect';
import InfiniteContainer from './InfiniteContainer';
import defaultData from './const/defaultData';

class Minishop extends SafePureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedId: false,
    };
    this.fields = defaultsDeep(props.fields, defaultData);
  }

  onItemSelect = id => this.setState({ selectedId: id });

  onBack = () => this.setState({ selectedId: false });

  getBackLink = () => (
    <p href="#" onClick={this.onBack}>
      <Icon name="arrow-left" /> Back
    </p>
  );

  safeRender() {
    const { selectedId } = this.state;
    const Title = this.props.fields.Title.value;
    const SubTitle = this.props.fields.SubTitle.value;
    const Items = this.props.fields.Items.value;
    return (
      <div css={[wrapper, isMobileOnly ? width100 : null]}>
        <div
          css={
            selectedId
              ? isMobileOnly
                ? containerMovedOver
                : containerMoved
              : container
          }
        >
          <div css={[titleContainer, isMobileOnly ? null : flexed]}>
            <div css={title}>{Title}</div>
            <div css={subTitle}>{SubTitle}</div>
          </div>
          <div css={itemsContainer}>
            {!isMobileOnly && (
              <div css={selectedId ? backLinkShowed : backLink}>
                {this.getBackLink()}
              </div>
            )}
            <InfiniteContainer
              selectedId={selectedId}
              Items={Items}
              onClick={this.onItemSelect}
            />
            {!isMobileOnly && <div css={fadedTop} />}
            {!isMobileOnly && <div css={fadedBottom} />}
          </div>
        </div>

        <div
          css={[
            selectedId
              ? isMobileOnly
                ? itemContentShowedFully
                : itemContentShowed
              : itemContent,
            isMobileOnly ? fixedContainer : null,
            isMobileOnly ? width100 : null,
          ]}
        >
          {isMobileOnly && (
            <div css={[fixedBack, selectedId ? fixedBackShowed : null]}>
              {this.getBackLink()}
            </div>
          )}
          COMING SOON
        </div>
      </div>
    );
  }
}

Minishop.displayName = 'Minishop';

Minishop.propTypes = {
  Title: PropTypes.shape({
    value: PropTypes.string,
  }),
  Description: PropTypes.shape({
    value: PropTypes.string,
  }),
  SubTitle: PropTypes.shape({
    value: PropTypes.string,
  }),
  Items: PropTypes.shape({
    value: PropTypes.arrayOf(
      PropTypes.shape({
        Image: PropTypes.shape({
          src: PropTypes.string,
          alt: PropTypes.string,
          caption: PropTypes.string,
        }),
        Title: PropTypes.string,
      }),
    ),
  }),
};

export default Minishop;
